export default __webpack_public_path__ + "static/media/small.a1332141.jpg";